import {RegisterFormDef} from "./RegisterFormDef";

export const OauthRegisterFormDef = {
  tirCarnetHolderCode: {...RegisterFormDef.tirCarnetHolderCode},
  firstName: {...RegisterFormDef.firstName},
  lastName: {...RegisterFormDef.lastName},
  phoneNumber: {...RegisterFormDef.phoneNumber},
  preferredLanguage: {...RegisterFormDef.preferredLanguage},
};